<template>
    <div class="text-caption font-weight-light text-grey ps-4">Maksimal {{ limit }} opsi</div>
    <template v-for="(option, index) in props.options" :key="index">
        <v-checkbox :rules="rules" v-model="modelValue" :label="option" :value="option"
            :disabled="modelValue.length >= limit && !modelValue.includes(option)"
            :hide-details="index != props.options.length - 1"></v-checkbox>
    </template>
</template>

<script setup>
import i18n from "@/i18n";
import { defineProps, defineModel } from "vue"

const modelValue = defineModel({
    type: Array,
    default: [],
    required: true
})

const props = defineProps({
    options: {
        type: Array,
        default: () => {
            return []
        },
        required: true
    },
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },
    limit: {
        type: Number,
        default: () => {
            return 1
        },
        required: true
    }
})

const rules = [
    (v) => {
        return !props.required || v?.length > 0 || i18n.global.t("customer-info.general.rules.checkbox-field.valid")
    }
]

</script>

<style lang="scss" scoped></style>